import { toast } from "sonner";
import i18n from "i18next";

// Sessions time out on the server (after a period without activity, and a maximum time after
// login). Every authenticated response carries a renewed token, which is stored here; when the
// session has ended, `onExpired` runs once and the user is told why they were logged out.

const tokenExpiry = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return payload.exp * 1000;
  } catch {
    return 0;
  }
};

const notify = () => toast.warning(i18n.t("errors.session_expired"), { id: "session-expired" });

export function trackSession(client, tokenKey, onExpired) {
  client.interceptors.response.use(
    (res) => {
      const renewed = res.headers["x-session-token"];
      if (renewed && localStorage.getItem(tokenKey)) localStorage.setItem(tokenKey, renewed);
      return res;
    },
    (err) => {
      // a 401 on a request that carried a token: the session is over
      const isLogin = /\/auth\/login$/.test(err.config?.url || "");  // a wrong password is not a timeout
      if (err.response?.status === 401 && !isLogin && err.config?.headers?.Authorization && localStorage.getItem(tokenKey)) {
        localStorage.removeItem(tokenKey);
        notify();
        onExpired();
      }
      return Promise.reject(err);
    },
  );
}

// Logs out an idle tab when its token runs out, without waiting for the next request.
export function watchExpiry(tokenKey, onExpired) {
  const id = setInterval(() => {
    const token = localStorage.getItem(tokenKey);
    if (token && tokenExpiry(token) < Date.now()) {
      localStorage.removeItem(tokenKey);
      notify();
      onExpired();
    }
  }, 15000);
  return () => clearInterval(id);
}
